import dayjs from "dayjs";
import { createContext, useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getLastSixMonth, getLastSixWeeks } from "../../../../plugins/monthList";
import { Level } from "../components/ComissionStatement/components";
import { useGetAgentBonusHeader } from "../hooks/comissionreport.hooks";

const ComissionContext = createContext({
  levels: [],
  setLevels: () => { },
  selectedMonth: null,
  setSelectedMonth: () => { },
  selectedWeek: null,
  setSelectedWeek: () => { },
  agentBonusId: null,
  setAgentBonusId: () => { },
  months: [],
  setMonths: () => { },
  weeks: [],
  setWeeks: () => { },
  comissionHeader: undefined,
  isHeaderLoading: true,
  isHeaderError: false,
  levelBonusRate: [],
  setLevelBonusRate: () => { },
});

export const ComissionContextProvider = ({ children }) => {
  const lastSixWeeks = getLastSixWeeks()
  const { t } = useTranslation();
  const [levels, setLevels] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [selectedWeek, setSelectedWeek] = useState(lastSixWeeks[0]);
  const [agentBonusId, setAgentBonusId] = useState(null);
  const [months, setMonths] = useState([]);
  const [weeks, setWeeks] = useState(lastSixWeeks);
  const [levelBonusRate, setLevelBonusRate] = useState([]);

  // const {
  //   data: comissionHeader,
  //   isLoading: isHeaderLoading,
  //   isError: isHeaderError,
  // } = useGetAgentBonusHeader({
  //   params: {
  //     period_month: selectedMonth?.value,
  //   },
  //   options: {
  //     enabled: selectedMonth !== null,
  //   },
  // });

  const {
    data: comissionHeader,
    isLoading: isHeaderLoading,
    isError: isHeaderError,
  } = useGetAgentBonusHeader({
    params: {
      period_date: selectedWeek?.value?.split('~')[0],
      // period_end: selectedWeek?.value?.split('~')[1],
    },
    options: {
      enabled: !!selectedWeek,
    },
  });

  useEffect(() => {
    const thismonth = dayjs().month();
    const thisyear = dayjs().year();
    const lastSixMonths = getLastSixMonth(thismonth, thisyear, t);
    setMonths(lastSixMonths);
    setSelectedMonth(lastSixMonths[0]);
  }, []);

  const getLevelBonusRate = (data) => {
    const final = [];
    if (!data) return final;
    const levelGroup = Object.keys(data);
    levelGroup?.map((levelName) => {
      final.push({
        level: levelName.split("-")[1],
        bonus_rate: data[levelName]?.bonus_rate,
      });
    });
    return final;
  };

  useEffect(() => {
    if (comissionHeader) {
      const bonusId = comissionHeader.data.agent_bonus_id?.length > 0 ? comissionHeader.data.agent_bonus_id : 0
      setAgentBonusId(bonusId);
      const _level = comissionHeader.data.agent_level_bonus;
      const levelBonus = Object.keys(_level).map((key, index) => {
        const currentLevel = parseInt(key.split("-")[1]);
        return {
          key: `level_bonus_${currentLevel}`,
          title: t("mobile.comission.tab.levelBonus", { level: currentLevel }),
          component: <Level level={currentLevel} />,
          destroyOnClose: true,
        };
      });
      setLevels(levelBonus);
      console.debug("comissionHeader", comissionHeader.data);
      const bonusRate = getLevelBonusRate(comissionHeader?.data?.agent_level_bonus);
      setLevelBonusRate(bonusRate);
    }
  }, [comissionHeader]);

  return (
    <ComissionContext.Provider
      value={{
        levels,
        setLevels,
        selectedMonth,
        setSelectedMonth,
        selectedWeek,
        setSelectedWeek,
        agentBonusId,
        setAgentBonusId,
        months,
        setMonths,
        weeks,
        setWeeks,
        comissionHeader,
        isHeaderLoading,
        isHeaderError,
        levelBonusRate,
        setLevelBonusRate,
      }}
    >
      {children}
    </ComissionContext.Provider>
  );
};
export const useComission = () => {
  const WebsocketValue = useContext(ComissionContext);
  return WebsocketValue;
};
